import http from "./http";
async function uploadLog(config) {
    await http.post('/common/createCommonLog', {
        name: config.name,
        path: config.path,
        line: config.line,
        source_type: config.source_type || 2,
        action: config.action,
        message: config.message,
        status: config.status || 2,
        data: config.data || {}, 
    });
}
export default {
    uploadLog
}